import { PERSONAL_MENU_ITEMS, PROJECT_MENU_ITEMS } from './constants';
import { AuthManager } from '~/components/ui/shadcn/components/supabase-manager/Auth.client';
import { DatabaseManager } from '~/components/ui/shadcn/components/supabase-manager/Database.client';
import { LogsManager } from '~/components/ui/shadcn/components/supabase-manager/Logs.client';
import { SecretsManager } from '~/components/ui/shadcn/components/supabase-manager/Secrets.client';
import { StorageManager } from '~/components/ui/shadcn/components/supabase-manager/Storage.client';
import { SuggestionsManager } from '~/components/ui/shadcn/components/supabase-manager/Suggestions.client';
import { UsersManager } from '~/components/ui/shadcn/components/supabase-manager/Users.client';
import { chatStore } from '~/lib/stores/chat';
import { SettingsPage } from '~/lib/stores/menu';
import { projectStore } from '~/lib/stores/project';

export const getInitialPage = (initialPage?: SettingsPage) => {
  if (initialPage) {
    return initialPage;
  }

  if (chatStore.started.get() && projectStore.permissions.get().canOpenProjectSettings) {
    return PROJECT_MENU_ITEMS.items[0].id;
  }

  return PERSONAL_MENU_ITEMS.items[0].id;
};

export const getDatabaseComponent = (title: SettingsPage) => {
  switch (title) {
    case SettingsPage.DatabaseGeneral: {
      return <DatabaseManager />;
    }
    case SettingsPage.DatabaseStorage: {
      return <StorageManager />;
    }
    case SettingsPage.DatabaseAuth: {
      return <AuthManager />;
    }
    case SettingsPage.DatabaseUsers: {
      return <UsersManager />;
    }
    case SettingsPage.DatabaseSuggestions: {
      return <SuggestionsManager />;
    }
    case SettingsPage.DatabaseLogs: {
      return <LogsManager />;
    }
    case SettingsPage.DatabaseSecrets: {
      return <SecretsManager />;
    }
    default: {
      return null;
    }
  }
};
